import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchRestaurantFooter } from "../../actions/footerActions";
import { useNavigate, useParams } from "react-router-dom";
import "./css/Footer.css";

function Footer() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const footerData = useSelector((state) => state.footer?.data || {});
  const restaurantName = footerData.restaurant_name || "Restaurant";
  const address = footerData.address || "";
  const phone = footerData.phone || "";
  const email = footerData.email || "";
  const hours = footerData.opening_hours || "";
  const description = footerData.description || "Authentic Indian cuisine, prepared with care.";
  const { restaurantId, tableId } = useParams();
  useEffect(() => {
    if (restaurantId) dispatch(fetchRestaurantFooter(restaurantId)).catch(() => {});
  }, [dispatch, restaurantId]);

  const homePath =
    `/${restaurantId}/table/${tableId}`;

  const handleHome = () => {
    navigate(homePath);

    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, 100);
  };

  const handleMenu = () => {
    navigate(`${homePath}#menu`);

    setTimeout(() => {
      document
        .getElementById("menu")
        ?.scrollIntoView({
          behavior: "smooth",
        });
    }, 150);
  };

  return (
    <footer className="t6-footer">

      {/* TOP DECORATIVE WAVE */}
      <div className="t6-footer-wave">
        <svg
          viewBox="0 0 1440 100"
          preserveAspectRatio="none"
        >
          <path
            d="
              M0,50
              C180,95 300,5 480,45
              C660,85 780,10 960,45
              C1140,80 1260,5 1440,45
              L1440,100
              L0,100
              Z
            "
          />
        </svg>
      </div>

      <div className="t6-footer-content">

        {/* BRAND */}
        <div className="t6-footer-brand">

          <button
            className="t6-footer-logo"
            onClick={handleHome}
          >
            {restaurantName}
          </button>

          <div className="t6-footer-line"></div>

          <p className="t6-footer-tagline">
            {description}
          </p>

          <div className="t6-footer-wave-symbol">
            ~
          </div>

        </div>

        {/* NAVIGATION */}
        <div className="t6-footer-column">

          <h4>EXPLORE</h4>

          <button onClick={handleHome}>
            Home
          </button>

          <button onClick={handleMenu}>
            Menu
          </button>

          <button
            onClick={() =>
              document
                .getElementById("t6-story")
                ?.scrollIntoView({
                  behavior: "smooth",
                })
            }
          >
            Our Story
          </button>

          <button
            onClick={() =>
              document
                .getElementById("t6-gallery")
                ?.scrollIntoView({
                  behavior: "smooth",
                })
            }
          >
            Gallery
          </button>

        </div>

        {/* CONTACT */}
        <div className="t6-footer-column">

          <h4>VISIT US</h4>

          <p>
            {address}
          </p>

          <p className="t6-footer-contact">
            {phone}
          </p>

          <p className="t6-footer-contact">
            {email}
          </p>

        </div>

        {/* HOURS */}
        <div className="t6-footer-column">

          <h4>OPENING HOURS</h4>

          <p>{hours}</p>

        </div>

      </div>

      <p className="t6-footer-disclaimer" style={{ textAlign: "center", padding: "8px 16px", fontSize: "12px" }}>
        Food images are for presentation purposes only. Actual items may vary.
      </p>

      {/* BOTTOM */}
      <div className="t6-footer-bottom">

        <div>
          © {new Date().getFullYear()} {restaurantName}
        </div>

        <div className="t6-footer-made">
          INDIAN CUISINE • MADE WITH CARE
        </div>

        <button
          className="t6-back-top"
          onClick={() =>
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            })
          }
        >
          ↑ TOP
        </button>

      </div>

    
      {/* Restaurant social profiles (only show configured HTTPS/HTTP URLs) */}
      {[
        { field: "facebook_url", label: "Facebook", glyph: "f" },
        { field: "instagram_url", label: "Instagram", glyph: "◎" },
        { field: "youtube_url", label: "YouTube", glyph: "▶" },
        { field: "whatsapp_url", label: "WhatsApp", glyph: "◉" },
      ].some(({ field }) => /^https?:\/\//i.test((footerData?.[field] || "").trim())) && (
        <nav aria-label="Restaurant social media" style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", alignItems: "center", gap: "14px", padding: "14px 18px" }}>
          {[
            { field: "facebook_url", label: "Facebook", glyph: "f" },
            { field: "instagram_url", label: "Instagram", glyph: "◎" },
            { field: "youtube_url", label: "YouTube", glyph: "▶" },
            { field: "whatsapp_url", label: "WhatsApp", glyph: "◉" },
          ].filter(({ field }) => /^https?:\/\//i.test((footerData?.[field] || "").trim())).map(({ field, label, glyph }) => (
            <a key={field} href={footerData[field].trim()} target="_blank" rel="noopener noreferrer" aria-label={label} title={label}
               style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", minWidth: "32px", minHeight: "32px", color: "inherit", textDecoration: "none", fontWeight: 700, fontSize: "20px" }}>
              {glyph}
            </a>
          ))}
        </nav>
      )}
    </footer>
  );
}

export default Footer;